export default "__VITE_PUBLIC_ASSET__68847008__"